import { useBreakpointValue } from '@genial/utils';
import { ScrollView, View } from 'native-base';

import { ContainerWrapper } from '../..';
import { useBatchTicketSent } from '../../hooks';

import { Content } from './components/Content';
import { Footer } from './components/Footer';
import { Header } from './components/Header';

export const BatchTicketSent = () => {
  const { data, handleFollowTicket, handleGoBack, handleNewTicket } = useBatchTicketSent();
  const Wrapper = useBreakpointValue({
    base: ({ children }) => <View minW="container">{children}</View>,
    lg: ({ children }) => (
      <ScrollView showsVerticalScrollIndicator={false}>
        <View minW="container">{children}</View>
      </ScrollView>
    ),
  });

  return (
    <Wrapper>
      <ContainerWrapper>
        <Header handleGoBack={handleGoBack} />
        <Content data={data} />
      </ContainerWrapper>
      <Footer handleFollowTicket={handleFollowTicket} handleNewTicket={handleNewTicket} />
    </Wrapper>
  );
};
